import * as React from "react";
const SvgMenu = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20 18H4M20 12H4M20 6H4", stroke: "black", strokeWidth: 2, strokeLinecap: "round" }));
export default SvgMenu;
